import React from 'react';
import { Box } from '@mui/material';

export default function Collections() {
    return (
        <Box sx={{ padding: 3, textAlign: 'center' }}>
            <h3 style={{ color: '#666' }}>COLLECTIONS</h3>
            <p style={{ color: '#999' }}>Coming soon...</p>
        </Box>
    );
}
